import { Badge } from "@/components/ui/badge";

const PREVIEW_LIMIT = 10;

interface CurrentValueItem {
  id: string;
  displayValue: string;
}

interface BulkEditValuesPreviewProps {
  currentValues: CurrentValueItem[];
}

export function BulkEditValuesPreview({ currentValues }: BulkEditValuesPreviewProps) {
  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Current Values (Preview)</label>
      <div className="max-h-32 overflow-y-auto border rounded-lg p-3 bg-card-50">
        <div className="space-y-1">
          {currentValues.slice(0, PREVIEW_LIMIT).map((item, index) => (
            <div key={item.id} className="flex items-center justify-between text-sm">
              <span className="text-gray-600 dark:text-gray-400">Item {index + 1}:</span>
              <Badge variant="outline" className="text-xs">
                {item.displayValue}
              </Badge>
            </div>
          ))}
          {currentValues.length > PREVIEW_LIMIT && (
            <div className="text-xs text-gray-500 text-center pt-1">
              ... and {currentValues.length - PREVIEW_LIMIT} more items
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
